// extracted by mini-css-extract-plugin
module.exports =  {"landingContainer":"SnylXiO8"};